import gql from 'graphql-tag';

import { backgroundTaskFields } from '@graphql/queries/backgroundTasks';

/**
 * Org-wide live feed for the tray panel (#263 on the server). Returns
 * every `BackgroundTaskOutput` transition for the current org regardless
 * of type/entity. Per the server docstring (`Lagged(n)` events from slow
 * subscribers are silently dropped), state is recoverable by re-running
 * the `backgroundTasksTray` query — the FE does this on every WS
 * reconnect via `@hooks/useWsReconnect`.
 */
export const backgroundTaskUpdatedSubscription = gql`
  subscription BackgroundTaskUpdated {
    backgroundTaskUpdated {
      ...BackgroundTaskFields
    }
  }
  ${backgroundTaskFields}
`;
